// @tailwindcss/forms draws the chevron as a background image; pr-10 keeps the text clear of it.
export const SELECT_CLASS =
  "h-9 rounded-md border border-spend-field bg-white pl-3 pr-10 text-sm normal-case text-gray-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export const LABEL_CLASS = "flex items-center gap-3 text-xs font-semibold uppercase tracking-wide text-gray-500";

export const PANEL_CLASS = "rounded-lg border border-spend-border bg-white";
